import { Link } from 'react-router-dom';
import '../styles/NotFound.css';

const NotFound = () => (
  <div className='not-found'>
    <h1>Page not found</h1>
    <p>That link does not match anything in the shop.</p>
    <Link to='/' className='not-found-link'>
      Back home
    </Link>
    <Link to='/shop' className='not-found-link secondary'>
      Browse the shop
    </Link>
  </div>
);

export default NotFound;
